import { FEATURE_FLAGS } from '../constant/featureFlags';
import { useFeatureFlag } from '../hooks/useFeatureFlag';
import { useRoyaltiesRouteFlags } from '../hooks/useRoyaltiesRouteFlags';
import { RoyaltiesSectionTabsLayout } from './RoyaltiesSectionTabsLayout';
import { royaltiesHistoricLayoutConfig } from './royaltiesLayoutConfig';

/**
 * MSR3 shell for the historic Royalties page: title is "Historic Royalties"
 * when Royalties ANZ or World is flagged on, otherwise "Royalties";
 * segmented tab navigation, and outlet for tab content.
 *
 * Paid Royalties embeds an MSR2 route that ships separately (APP-2523), so its
 * tab is behind its own flag rather than following the page's.
 */
export const RoyaltiesLayout = () => {
  const { isEarningsStatementsGroup } = useRoyaltiesRouteFlags();
  const [isPaidRoyaltiesTabEnabled] = useFeatureFlag(
    FEATURE_FLAGS.MSR3_PAID_ROYALTIES_TAB,
  );
  const pageTitle = isEarningsStatementsGroup
    ? 'Historic Royalties'
    : 'Royalties';
  const tabs = isPaidRoyaltiesTabEnabled
    ? royaltiesHistoricLayoutConfig.tabs
    : royaltiesHistoricLayoutConfig.tabs.filter(
        ({ section }) => section !== 'paid-royalties',
      );

  return (
    <RoyaltiesSectionTabsLayout
      {...royaltiesHistoricLayoutConfig}
      pageTitle={pageTitle}
      tabs={tabs}
    />
  );
};
